import {Directive, ElementRef, AfterViewInit, Input, Output, EventEmitter} from '@angular/core';

declare var $: any;

@Directive({
    selector: '[appDateTimePicker]'
})
export class DateTimePickerDirective implements AfterViewInit {
    @Input() value: any;
    @Output() onChange = new EventEmitter<string>();
    private element: any;

    constructor(el: ElementRef) {
        this.element = $(el.nativeElement);
    }

    ngAfterViewInit() {
        this.element.daterangepicker({
            autoApply: true,
            singleDatePicker: true,
            timePicker: true,
            locale: {
                format: 'DD/MM/YYYY hh:mm A'
            }
        });
        this.element.val(this.value).trigger('change');
        this.element.on('change', (e: any) => {
            this.onChange.emit($(e.target).val());
        });
    }
}
